import styled from "@emotion/styled";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export const CartTemplateModalHeader = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	padding: "16px 24px",
	"& .MuiSvgIcon-root": {
		cursor: "pointer",
		[theme.breakpoints.down("md")]: {
			position: "absolute",
			top: 20,
			right: 28
		}
	},
	div: {
		display: "flex",
		flexDirection: "column",
		h6: {
			margin: 0,
			color: theme.palette.text.secondary
		},
		p: {
			margin: 0,
			fontSize: 14,
			letterSpacing: ".17px",
			lineHeight: "20px"
		}
	}
}));

export const DeleteTemplateButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.semanticColors.error,
	borderColor: theme.project.colors.semanticColors.error,
	display: "flex",
	alignItems: "center"
}));

export const SaveButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.secondaryColors.primary,
	display: "flex",
	alignItems: "center",
	span: {
		color: theme.project.colors.secondaryColors.primary
	}
}));

export const SavingIcon = styled(CircularProgress)(({ theme }) => ({
	color: theme.project.colors.secondaryColors.primary,
	height: "20px",
	width: "20px"
}));

export const CartTemplateModalBody = styled.div<{ isError: boolean }>(({ theme, isError }) => ({
	padding: "0 24px 24px 24px",
	p: {
		marginTop: 0,
		fontSize: 14,
		letterSpacing: ".17px",
		lineHeight: "20px"
	},
	"& .MuiTextField-root": {
		width: "100%",
		"& label:not(.MuiInputLabel-shrink)": {
			top: "-7px"
		},
		label: {
			color: isError ? theme.project.colors.semanticColors.error + "!important" : "auto"
		},
		div: {
			input: {
				"&::placeholder": {
					color: theme.project.colors.fontColors.secondary,
					opacity: 1
				},
				lineHeight: 24,
				height: 40,
				padding: 0
			},
			fieldset: {
				borderColor: isError ? theme.project.colors.semanticColors.error + "!important" : "auto",
				borderWidth: "1px !important"
			},
			padding: "0 12px"
		}
	},
	span: {
		color: isError ? theme.project.colors.semanticColors.error : "auto"
	}
}));

export const CartTemplateModalButtons = styled.div(({ theme }) => ({
	display: "flex",
	gap: 16,
	marginTop: 16,
	button: {
		width: "100%",
		height: 42,
		fontSize: 15
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse"
	}
}));
